import { isBelowiOS26 } from '@/lib/utils/iosCompat'
import { Stack, type NativeStackNavigationOptions } from 'expo-router'
import { useTheme } from 'expo-router/react-navigation'
import { Platform } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

export default function TabStackLayout({ title }: { title: string }) {
  const theme = useTheme()

  return (
    // iPadOS 26 sidebar floats over the tab content and only adds a left safe-area inset,
    // which lists ignore; pad the stack so the content shrinks beside the sidebar instead
    <SafeAreaView edges={['left', 'right']} style={{ flex: 1, backgroundColor: theme.colors.background }}>
      <Stack
        screenOptions={{
          title: '',
          headerLargeTitle: true,
          headerShadowVisible: false,
          headerBackButtonDisplayMode: 'minimal',
          contentStyle: { backgroundColor: theme.colors.background },
          ...Platform.select<NativeStackNavigationOptions>({
            ios: {
              // Opaque header on iOS <26 desyncs RN touch/measure coordinates from the
              // visual layout after push+pop (taps land ~header-height off and get
              // suppressed by Pressability), so keep the header transparent and use a
              // blur effect for the pre-26 look.
              headerTransparent: true,
              ...(isBelowiOS26 ? { headerBlurEffect: 'systemChromeMaterial' as const } : {}),
            },
            android: {
              headerTransparent: false,
              headerStyle: { backgroundColor: theme.colors.background },
            },
          }),
        }}
      >
        <Stack.Screen name="index" options={{ title }} />
      </Stack>
    </SafeAreaView>
  )
}
